module.exports = __webpack_public_path__ + "static/img/R-C.08cd93d6.png";